import React, {forwardRef, Ref, useEffect, useImperativeHandle, useRef, useState} from 'react'


import {useTypedSelector} from '../../../../../../hooks/useTypeSelector';

import {FlyerPageDto, PopupSettings} from '../../../../../../dtos'
import Canvas, {ICanvasRef} from '../../../../../../com/canvas/Canvas'

import Loader from '../../../../../../com/loader/Loader'

import {Spots} from '../../../../../com/canvas/spots/Spots'

import './FlyerPage.scss'
import {ActionType} from "../../../../../../store/actionTypes";
import {getSettingsForPopup} from "../../../../pages/getSetttingsForPopup";
import StatusPopup, {StatusPopupType} from "../../../../../../com/statusPopup/StatusPopup";
import {
    FLYER_CANVAS_HEIGHT,
    FLYER_CANVAS_WIDTH,
    getCanvasSize, getCanvasWrapperSize,
    updateCanvasSize
} from '../../../../../../globals';
import {useDispatch} from "react-redux";
import {getFlippingFlyer} from "../../../../../../store";
import {AsyncImageWithLoader} from "../../../../../../com/imageWithLoader/imageWithLoader";
// import {ReactComponent as ImageWithError} from "../../../../../../assets/editors/image_with_error.svg";
import {
    startUploadingImagesProgressPopup
} from "../../../../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {getIconStyle} from "../../../../../../globals/globFunctions";

export interface IFlyerPageRef {
    setNextGridSize: (rows: number, columns: number) => void;
    reInit: () => void;
    showLoader: (value: boolean) => void;
}

export interface IFlyerPage {
    data?: FlyerPageDto,
}


export const FlyerPage = forwardRef((props: IFlyerPage, ref: Ref<IFlyerPageRef>) => {
    const dispatch = useDispatch();
    const {toggleActionsForFlyers} = useTypedSelector((state) => state);
    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyerIconStyleType = flyerDetailsState.flyGusRec?.gusIconContrast || 1;
    // const mainGuiColorForFlyer = flyerDetailsState.flyGusRec?.gusPrimaryColorRgb || "#ffffff";
    const iconStyleData = getIconStyle(flyerIconStyleType);

    useImperativeHandle(ref, () => ({
        reInit,
        showLoader,
        setNextGridSize,
    }));

    const timer = useRef<NodeJS.Timeout | undefined>();
    const canvasRef = useRef<ICanvasRef>(null)

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isModalPopup, setModalPopup] = useState<boolean>(false);
    const [popupSettings, setPopupSettings] = useState<PopupSettings>({})

    let canvasWidth = FLYER_CANVAS_WIDTH;
    let canvasHeigth = FLYER_CANVAS_HEIGHT;

    const spots = useRef<Spots | null>(null)
    if (spots.current === null) {
        spots.current = new Spots(true, canvasWidth, canvasHeigth, false, true, iconStyleData)
    }

    const reInit = () => {
        dispose();

        // init
        spots.current = new Spots(true, canvasWidth, canvasHeigth, false, true, iconStyleData);
    }

    const dispose = () => {

        if (spots.current) {
            spots.current!.dispose();
            if (spots.current!.parent) {
                spots.current!.parent.removeChild(spots.current!)
            }
            spots.current = null;
        }

        if (canvasRef.current) {
            canvasRef.current.reInitCanvas();
        }
    }

    const showLoader = (value: boolean) => {
        setIsLoading(value)
    }

    const setNextGridSize = (rows: number, columns: number) => {
        spots.current!.setNextGgridSize(rows, columns)
    }

/*
    const onImageLoadComplete = (isComplete: boolean) => {
        showLoader(isComplete)
    }
*/

    const reInitCanvas = () => {
        if(props.data !== null && canvasRef.current && props.data?.flyerPageSpots){
            reInit();

            const {containerWidth, containerHeight} = getCanvasWrapperSize();

            let canvasDimensions = getCanvasSize(props.data!.flpWidthPx!, props.data!.flpHeightPx!, toggleActionsForFlyers.isZoomIn, containerWidth, containerHeight)
            updateCanvasSize(
                spots.current!,
                props.data!.flpWidthPx!,
                props.data!.flpHeightPx!,
                toggleActionsForFlyers.isZoomIn
            )

            spots.current!.initSpotsDtos(props.data!, canvasDimensions.width, canvasDimensions.height, true, false)
            canvasRef.current?.addChild(spots.current!);
        }

    }

    useEffect(() => {
        if (props.data !== null && canvasRef.current && props.data?.flyerPageSpots) {
            if (timer.current) {
                clearTimeout(timer.current)
            }

            timer.current = setTimeout(() => {
                setIsLoading(false)
            }, 2000);
            reInitCanvas();
        } else {
            canvasRef.current?.addChild(spots.current!);
        }

        return () => {
            if (timer.current) {
                clearTimeout(timer.current)
            }
        };

    }, [props.data, toggleActionsForFlyers.isZoomIn])

    useEffect(() => {
        if (flippingFlyerState.type === ActionType.POST_FLYER_PROMOITEMS_SUCCESS
            || flippingFlyerState.type === ActionType.POST_FLYER_PROMOS_AND_ITEMS_SUCCESS
        ) {
            let message: string[] = [];
            let modalName: string = 'successfullyUpload'
            if (flippingFlyerState.type === ActionType.POST_FLYER_PROMOS_AND_ITEMS_SUCCESS) {
                if (flippingFlyerState.successInfo && flippingFlyerState.successInfo.severityLevel === 'Info') {
                    message = flippingFlyerState.successInfo.userFriendlyMessage.split(`\r\n`)
                        .filter(key => key !== '');
                    modalName = `successfullyUploadWithSomePromosAndItemsErrors`;
                    // message.push(`${flippingFlyerState.successInfo.userFriendlyMessage}`);
                } else {
                    message.push(`Promotions and Items uploaded successfully`);
                }
                // } else if (flippingFlyerState.type === ActionType.POST_IMAGES_FOR_PROMOTIONS_SUCCESS) {
                //     if (flippingFlyerState.successInfo && flippingFlyerState.successInfo.severityLevel === 'Info') {
                //         message = flippingFlyerState.successInfo.userFriendlyMessage.split(`\r\n`)
                //             .filter(key => key !== '');
                //         modalName = `successfullyUploadWithSomePromosAndItemsErrors`;
                //         // message.push(`${flippingFlyerState.successInfo.userFriendlyMessage}`);
                //     }
                //
                // } else if (flippingFlyerState.type === ActionType.POST_IMAGES_FOR_ITEMS_SUCCESS) {
                //     if (flippingFlyerState.successInfo && flippingFlyerState.successInfo.severityLevel === 'Info') {
                //         message = flippingFlyerState.successInfo.userFriendlyMessage.split(`\r\n`)
                //             .filter(key => key !== '');
                //         modalName = `successfullyUploadWithSomePromosAndItemsErrors`;
                //         // message.push(`${flippingFlyerState.successInfo.userFriendlyMessage}`);
                //     }
            } else {
                message.push(`Promotion and item images upload has started, give it a few minutes to complete.`);
            }
            setPopupSettings({
                    typeStatus: 0,
                    title: '',
                    subTitle: '',
                    messages: message,
                    modalName: modalName,
                }
            )
            setModalPopup(true);
            if (props.data) {
                dispatch(getFlippingFlyer(props.data.flpFlyRecId!))
            }
        } else if (flippingFlyerState.type === ActionType.POST_IMAGES_FOR_PROMOTIONS_START
            || flippingFlyerState.type === ActionType.POST_IMAGES_FOR_PROMOTIONS_ITEMS_START
            || flippingFlyerState.type === ActionType.POST_IMAGES_FOR_ITEMS_START
        ) {
            dispatch(startUploadingImagesProgressPopup());
        } else if (flippingFlyerState.type && flippingFlyerState.type!.indexOf('ERROR') > -1) {
            if (props.data) {
                dispatch(getFlippingFlyer(props.data.flpFlyRecId!))
            }
        }

    }, [flippingFlyerState.loading])

    useEffect(() => {
        window.addEventListener('resize', reInitCanvas);
        return () => {
            window.removeEventListener('resize', reInitCanvas);
        }
    }, [props.data])

    useEffect(() => {
        return () => {
            // on unmount
            dispose();
        }
    }, []);

    let settingsForPopup = getSettingsForPopup(popupSettings);


    return (
        <div className="flyer_page_container">
            <AsyncImageWithLoader src={props.data?.flpImageUrl ? props.data?.flpImageUrl : ''} withoutLoader={true}/>

            <Canvas ref={canvasRef} id={'cavansTest'} width={canvasWidth} height={canvasHeigth}/>

            {isLoading &&
                <div className="flyer_page_container_loader">
                    <Loader show={isLoading}/>
                </div>
            }
            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={settingsForPopup.typeStatus ? settingsForPopup.typeStatus : StatusPopupType.CONFIRM}
                title={settingsForPopup.title ? settingsForPopup.title : 'SUCCESS'}
                subTitle={''}
                messages={settingsForPopup.messages}
                show={isModalPopup}
                handleClose={() => setModalPopup(false)}
            />
            }

        </div>
    )
})
